import { useMemo } from "react";
import { useSelector } from '../../../../util/store/store';
import { InfoMode } from '../../../../util/varibles/constants';
import { IActivityLog, IHarvest2, IOperation2 } from "../../../../util/varibles/interface";
import { selectOpDetail } from '../../constants';
import StepView from "./StepView";

interface IProps {
    data: IOperation2<IHarvest2>
}

const ActivityLog: React.FC<IProps> = ({ data }) => {
    const { activity_log, operation: { sub_operations, tanks } } = data;
    const infoMode = useSelector(selectOpDetail.infoMode);

    const deliveryTypes = useMemo(() => {
        return sub_operations.reduce((rs: Record<string, string>, item) => {
            const { delivery_types = [] } = item;
            delivery_types.forEach(sub => rs[sub.id] = sub.name);
            return rs;
        }, {});
    }, [sub_operations]);

    if (infoMode === InfoMode.PLAN) {
        return <>
            {activity_log.map((item, i) => <StepView key={i} data={item} op={data} deliveryTypes={deliveryTypes} />)}
        </>;
    }

    return <div className="flex flex-col">
        {activity_log.map((item, i) => {
            const { real_start_time, real_finish_time, real_sub_steps, sub_steps, ...args } = item
            let curretTanks: typeof tanks = [];
            const value: Partial<IActivityLog> = {
                ...args,
                est_start_time: real_start_time,
                est_finish_time: real_finish_time
            }

            if (real_sub_steps) {
                const groupByTank: Record<string, { total_weight: number, fish_amount: number }> = {};
                value.sub_steps = real_sub_steps.map(sub => {
                    const { tank_id, total_weight = 0, fish_amount = 0 } = sub;
                    if (groupByTank[tank_id]) {
                        groupByTank[tank_id].total_weight += total_weight
                        groupByTank[tank_id].fish_amount += fish_amount
                    } else {
                        groupByTank[tank_id] = { total_weight, fish_amount }
                    }
                    return {
                        ...sub,
                        sub_id: sub.unit_id,
                        est_start_time: sub.real_start_time,
                        est_finish_time: sub.real_finish_time
                    }
                }) as typeof value.sub_steps;
                curretTanks = tanks.map(({ id, name, real_density, max_density }) => ({ id, name, density: real_density, max_density, ...groupByTank[id] || {} }))
            }
            return <StepView key={i} data={value as IActivityLog} op={data} deliveryTypes={deliveryTypes} tanks={curretTanks} />
        })}
    </div>;
}

export default ActivityLog
